import CDRSPage from "pages/CDRs/CDRsPage";

const cdrsRoute = [
  {
    path: '/cdrs',
    exact: true,
    name: 'Lịch sử cuộc gọi',
    function: 'SYS_CDRS_VIEW',
    component: CDRSPage,
  },
];

export default cdrsRoute;
